export default "__VITE_ASSET__BxlA3cCj__"